import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStudioDisplay: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="studio-display, thunderbolt"><path fillRule="evenodd" clipRule="evenodd" d="M2 5.75C2 4.7835 2.7835 4 3.75 4H20.25C21.2165 4 22 4.7835 22 5.75V16.25C22 17.2165 21.2165 18 20.25 18H16V20.25C16 20.6642 15.6642 21 15.25 21H8.75C8.33579 21 8 20.6642 8 20.25V18H3.75C2.7835 18 2 17.2165 2 16.25V5.75ZM9.5 18V19.5H14.5V18H9.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconStudioDisplay;
